export default {

  // 申込チャネル区分(1:アプリ,2:Web(PC),3:Web(SP))
  // web-frontはアプリからの申込となる為、1が設定値となる。
  APPLICATION_CATEGORY_APP: 1,

  // PITLOCK 作業開始確定区分 (0:未確定 1:確定)
  START_DECISION_UNSURE: 0,
  START_DECISION_SURE: 1,

  // CF社APIのエラーコード:メンテナンス中
  PITLOCK_ERROR_CODE_MAINTENANCE: 5200,

  // CF社 CLS001 - APIのユーザー操作でエラーが発生する可能性が存在するエラーコード一覧

  // 作業日時日またぎエラー
  PITLOCK_ERROR_CODE_WORKING_DAY_OVER: '4223',
  // 作業開始日時予約可能範囲外エラー
  PITLOCK_ERROR_CODE_WORKING_START_TIME_OUT_OF_RANGE: '4224',
  // 作業終了日時予約可能範囲外エラー
  PITLOCK_ERROR_CODE_WORKING_END_TIME_OUT_OF_RANGE: '4225',
  // 作業時間帯予約受付不可エラー
  PITLOCK_ERROR_CODE_WORKING_TIME_INSPECTION_IMPOSSIBLE: '4226',
  // 作業時間帯予約枠空きなしエラー(ユーザー間で予約がバッティングしたケース)
  PITLOCK_ERROR_CODE_USER_CONFLICT: '4227',
  // PITLOCK通信エラー
  PITLOCK_ERROR_CODE_CONNECTION: '5002',

  // timyカーメンテURLの流入経路パラメータ
  // https://cls-com.backlog.com/view/PITLOCK-66#comment-83517047
  TIMY_CAR_MAINTE_RESERVE_CHANNEL_CODE: 4,

  // timyカーメンテURLのCF管理パラメータ
  // https://cls-com.backlog.com/view/PITLOCK-66#comment-83517047
  TIMY_CAR_MAINTE_CF_PARAM: '&utm_campaign=alliance&utm_medium=Affiliates&utm_source=cls',

  // メンテパック対応店
  MAINTENANCE_PACK_CORRESPONDENCE: 1,

  /**
   * APIの認証で参照されるパラメータ
   * @type {Array}
   */
  API_AUTH_HEADERS_PARAM: {
    'HTTP-X-DAPP-USERID': '1556004532',
    'HTTP-X-DAPP-REQUESTTIME': '1',
    'HTTP-X-DAPP-AUTHCD': 'ecf2ffc592842b4a70722844eb48d89e67b3fc17c7232792c82c79321e7aa631'
  },

  /**
   * 各APIで参照されるパラメータ
   * @type {Array}
   */
  API_HEADERS_PARAM: {
    APP_USERS_AUTH_ID: '012A345B678C901D234E567F890G123H',
    X_CLS_App_Version: '3.3.1/Android/5.0.2'
  },

  /**
   * GMO 決済分類
   * @type {Array}
   */
  GMO_PAYMENT_CLASSIFICATION: {
    FIRST_PAYMENT: 'first',
    LATE_FEES_SETTLEMENT: 'non'
  },

  /**
   * GMOリンクタイプ取得APIに渡すリクエストパラメータ（amount）
   * @type {String}
   */
  GMO_LINK_TYPE_API_AMOUNT: '500',

  /**
   * メンテパックコースID
   * @type {Array}
   */
  MAINTENANCE_PACK_COURCE: {
    COURCE_A: {
      ID: 1,
      NAME: 'メンテナンスパック_500'
    }
  }

}
